import React, { useState, useEffect } from 'react';

const ThemeToggleButton = () => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
  }, [darkMode]);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  return (
    <button className="toggle-button" onClick={toggleTheme} aria-label="Toggle Theme">
      <span></span>
    </button>
  );
};

export default ThemeToggleButton;
